// Application review workflow. Kept in sync with JobApplication.VALID_STATUSES
// on the backend (backend/models/JobApplication.js).

export const STATUS_FLOW = ['new', 'reviewing', 'interviewing', 'hired', 'not_a_fit', 'archived'];

export const STATUS_LABELS = {
  new: 'New',
  reviewing: 'Reviewing',
  interviewing: 'Interviewing',
  hired: 'Hired',
  not_a_fit: 'Not a Fit',
  archived: 'Archived',
};

export const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  ...STATUS_FLOW.map(value => ({ value, label: STATUS_LABELS[value] })),
];
